import { Injectable } from '@angular/core';
import { IIconService } from 'interfaces-lib';

@Injectable({ providedIn: 'root' })
export class InveniasIconService implements IIconService {
  getIcon(type: string | undefined): string {
    return type ? `invenias-icon ${type.toLowerCase()}` : '';
  }
}
